import WrapperLayout from 'components/Layout';
import Main from "./Components/Main"
const EnhancedValuation = () =>{
    return(
        <>
        <WrapperLayout>
            <Main/>
        </WrapperLayout>
    </>
    )
}
export default EnhancedValuation